import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./CorporateList.css";

function CorporateList() {
  const navigate = useNavigate();

  const [corporates, setCorporates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCorporates = async () => {
      try {
        const res = await axios.get("https://backend-xhl4.onrender.com/CorporateRoute/all");
        setCorporates(res.data.corporates || []);
      } catch (err) {
        setError("Failed to load corporate list.");
      } finally {
        setLoading(false);
      }
    };

    fetchCorporates();
  }, []);

  const handleViewDetails = (companyCode) => {
    navigate(`/corporate/${companyCode}`);
  };

  return (
    <div className="corporate-list-page">

      <h1 className="page-title">Corporate Partners</h1>
      <p className="page-subtitle">
        Explore the list of companies associated with PsyCare.
      </p>

      {loading && <p className="loading-text">Loading companies...</p>}
      {error && <p className="error-text">{error}</p>}

      <div className="corporate-grid">
        {!loading && corporates.length === 0 && (
          <p className="no-data-text">No corporate companies found.</p>
        )}

        {corporates.map((corp) => (
          <div className="corporate-card" key={corp.companyCode}>
            <h2 className="corp-name">{corp.companyName}</h2>

            <div className="corp-info">
              <p>
                <strong>Company Code:</strong> {corp.companyCode}
              </p>
              <p>
                <strong>Contact Person:</strong> {corp.contactPerson}
              </p>
              <p>
                <strong>Email:</strong> {corp.email}
              </p>
              <p>
                <strong>Phone:</strong> {corp.phone}
              </p>
            </div>

            <button
              className="view-btn"
              onClick={() => handleViewDetails(corp.companyCode)}
            >
              View Details
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CorporateList;
